<template>
  <div class="login-page">
    <div class="login-page__glow login-page__glow--primary"></div>
    <div class="login-page__glow login-page__glow--secondary"></div>

    <v-container fluid class="fill-height pa-0">
      <v-row align="center" justify="center" class="fill-height ma-0">
        <v-col cols="12" sm="10" md="5" lg="4">
          <v-card class="login-card">
            <v-card-text class="pa-8 pa-md-10">
              <div class="login-card__brand">
                <div class="login-card__logo">
                  <v-img contain :src="logo" alt="LOGO BRP"></v-img>
                </div>
                <div>
                  <span class="login-card__eyebrow">Backoffice BRP</span>
                  <h1 class="login-card__title">Acesse o painel administrativo</h1>
                  <p class="login-card__subtitle">
                    Entre com suas credenciais para continuar gerenciando a operação.
                  </p>
                </div>
              </div>

              <v-form ref="form" v-model="valid" @submit.prevent="login">
                <v-text-field
                  v-model="user.document"
                  label="CPF"
                  outlined
                  dense
                  prepend-inner-icon="mdi-card-account-details-outline"
                  v-mask="'###.###.###-##'"
                  :rules="rules"
                />

                <v-text-field
                  v-model="user.password"
                  label="Senha"
                  outlined
                  dense
                  prepend-inner-icon="mdi-lock-outline"
                  append-icon="mdi-eye"
                  :rules="rules"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                />

                <v-btn
                  type="submit"
                  :disabled="!valid"
                  :dark="valid"
                  color="primary"
                  class="mt-6"
                  large
                  block
                >
                  Entrar no backoffice
                </v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Authenticate } from "@/services/user/Authenticate";
import { CredentialType } from "@/types/user/Credential";
import { TokenType } from "@/types/user/Token";
export default defineComponent({
  data() {
    return {
      valid: false,
      user: {
        document: "",
        password: "",
      } as CredentialType,
      rules: [
        (value: string) => {
          if (value) return true;
          return "O campo é obrigatório";
        },
      ],
      showPassword: false,
      logo: require("../../assets/logo-login.png"),
    };
  },
  methods: {
    async login() {
      const authenticate = new Authenticate();
      await authenticate
        .execute(this.user)
        .then((res) => {
          const tokens = {
            accessToken: res.accessToken,
            refreshToken: res.refreshToken,
          } as TokenType;
          const tokensString = JSON.stringify(tokens);
          localStorage.setItem("tokens", tokensString);
          this.$router.push("/");
        })
        .catch(() => {
          this.$store.dispatch("showSnack", {
            message: "Erro ao efetuar o login",
            color: "red",
          });
        });
    },
  },
});
</script>

<style scoped>
.login-page {
  position: relative;
  min-height: calc(100vh - 48px);
  overflow: hidden;
}

.login-page__glow {
  position: absolute;
  border-radius: 999px;
  filter: blur(80px);
  opacity: 0.45;
}

.login-page__glow--primary {
  top: -80px;
  left: -60px;
  width: 260px;
  height: 260px;
  background: rgba(225, 29, 72, 0.28);
}

.login-page__glow--secondary {
  right: -80px;
  bottom: -100px;
  width: 320px;
  height: 320px;
  background: rgba(124, 58, 237, 0.2);
}

.login-card {
  position: relative;
  z-index: 1;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid rgba(226, 232, 240, 0.9);
  border-radius: 24px !important;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.12) !important;
}

.login-card__brand {
  display: flex;
  align-items: flex-start;
  gap: 18px;
  margin-bottom: 28px;
}

.login-card__logo {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 72px;
  height: 72px;
  padding: 12px;
  border-radius: 20px;
  background: linear-gradient(135deg, rgba(225, 29, 72, 0.12), rgba(124, 58, 237, 0.12));
}

.login-card__eyebrow {
  display: inline-block;
  margin-bottom: 8px;
  color: var(--color-primary);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.login-card__title {
  margin: 0;
  color: var(--color-text);
  font-size: 1.9rem;
  line-height: 1.12;
}

.login-card__subtitle {
  margin: 10px 0 0;
  color: var(--color-text-muted);
  line-height: 1.6;
}

@media (max-width: 600px) {
  .login-card__brand {
    flex-direction: column;
  }
}
</style>
